import React from 'react';

interface TestEnvironmentAlertProps {
    ambiente?: string;
}

const TestEnvironmentAlert: React.FC<TestEnvironmentAlertProps> = ({ ambiente }) => {

    if (ambiente !== 'Pruebas') {
        return null;
    }

    return (
        <div
            className="alert alert-danger alert-dismissible fade show m-0 rounded-0 text-white text-center py-2"
            role="alert"
            style={{
                backgroundColor: '#dc3545',
                borderColor: '#dc3545',
                color: 'white !important',
                fontSize: '14px',
                display: 'block',
                visibility: 'visible',
                opacity: '1',
                position: 'relative'
            }}
        >
            <strong>¡Atención!</strong> Actualmente se encuentra operando en el ambiente de pruebas. Los comprobantes generados no tienen validez tributaria.
        </div>
    );
};

export default TestEnvironmentAlert;
